import Vue from 'vue'

Vue.component(
  'work-in-progress', () => import('@/views/misc/WorkInProgress.vue')
)
